import { useAccessCache } from '../../utils/hooks/useAccessCache';
import { hubsSettingsCache } from '../../cache';
import { useMemo } from 'react';
export const useSavingMode = (options = {}) => {
  const state = useAccessCache({
    settingName: 'CRM:Properties:AutosaveMode',
    defaultValue: 'auto'
  }, hubsSettingsCache, options);
  return useMemo(() => {
    if (state.loading || state.error) {
      return state;
    }
    return {
      loading: false,
      data: state.data,
      error: undefined
    };
  }, [state]);
};